import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setLoginSession } from '../../utils/auth'; // Importing the helper logic

function Login() {
    const [username, setUsername] = useState('uberUser');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('')
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();

        if (password == "Uber@2026") {
            setLoginSession({ username });
            navigate('/');
            setError('')
        } else {
            setError("Invalid Password");
        }
    };

    return (
        <div className='login-container'>
            <div className='login-card-main'>
                <img src='/uploads/Brand/uber_white.webp' style={{ width: '70%', margin: 'auto', padding: '20px' }} />
                <div className='' >
                    <form onSubmit={handleSubmit} className='form'>
                        {/* <div className='input-group'>
                        <label>Username</label>
                        <input
                            type="text"
                            className='form-control'
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter username"
                            required
                        />
                    </div> */}
                        <div className='input-group'>
                            <label>Password</label>
                            <input
                                className='form-control'
                                type="password"
                                value={password}
                                onChange={(e) => { setPassword(e.target.value); setError('') }}
                                placeholder="Enter password"
                                required
                            />
                            {error ? <p className='error-text-login'>{error}</p> : <></>}
                        </div>
                        <button type="submit" className='login-btn'>Login</button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;